/**
 * communityVideos — API pública do módulo (facade).
 * A CommunityScreen e o resto do app importam SOMENTE daqui.
 *
 * Fase atual: camada de dados (serviço + hook de leitura).
 * Próxima fase: UI — VideoFeedSection ("Mais relevantes") e ShortsSection ("Atualizações").
 */

import * as communityVideosService from './services/communityVideosService';

export { communityVideosService };

// UI pública — a CommunityScreen importa só estas duas seções.
export { default as VideoFeedSection } from './components/VideoFeedSection';
export { default as ShortsSection } from './components/ShortsSection';
// Player reel reutilizável (perfil reaproveita p/ reproduzir vídeos do usuário).
export { default as VideoPlayerModal } from './components/VideoPlayerModal';

export { useInfiniteVideos, useUserVideos, selectVideoItems } from './hooks/useInfiniteVideos';
export { useUserVideoLikes, useToggleVideoLike, useCreateVideo, useDeleteVideo } from './hooks/useVideoMutations';
export { extractYoutubeId, fetchYoutubeMetadata } from './services/youtubeMetadata';
export {
  videoKeys,
  VIDEO_SORT,
  VIDEO_SOURCE,
  VIDEO_STATUS,
  VIDEO_PAGE_SIZE,
} from './constants';
